import { useEffect, useState } from 'react';
import { canAccessAdminDashboard } from '../util/adminAccess';
import { getAdminAccessApi } from '../util/api';

const useAdminAccess = currentUser => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      if (!currentUser?.id?.uuid) {
        if (!cancelled) {
          setIsAdmin(false);
          setIsChecking(false);
        }
        return;
      }

      const emailFallback = canAccessAdminDashboard(
        currentUser?.attributes?.email,
        currentUser
      );
      if (emailFallback) {
        if (!cancelled) {
          setIsAdmin(true);
          setIsChecking(false);
        }
        return;
      }

      try {
        const response = await getAdminAccessApi();
        if (!cancelled) {
          setIsAdmin(response?.data?.isAdmin === true);
          setIsChecking(false);
        }
      } catch {
        if (!cancelled) {
          setIsAdmin(false);
          setIsChecking(false);
        }
      }
    };

    check();
    return () => {
      cancelled = true;
    };
  }, [currentUser?.id?.uuid, currentUser?.attributes?.email]);

  return { isAdmin, isChecking };
};

export default useAdminAccess;
